module.exports = __webpack_public_path__ + "static/media/nftp-light-circular.c54a6825.png";